/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getPostOpRecoveries } from 'app/entities/post-op-recovery/post-op-recovery.reducer';
import { getEntities as getPregnancyCases } from 'app/entities/pregnancy-case/pregnancy-case.reducer';
import { PainScore } from 'app/shared/model/enumerations/pain-score.model';
import { createEntity, getEntity, reset, updateEntity } from './post-delivery-monitoring.reducer';

export const PostDeliveryMonitoringUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const postOpRecoveries = useAppSelector(state => state.postOpRecovery.entities);
  const pregnancyCases = useAppSelector(state => state.pregnancyCase.entities);
  const postDeliveryMonitoringEntity = useAppSelector(state => state.postDeliveryMonitoring.entity);
  const loading = useAppSelector(state => state.postDeliveryMonitoring.loading);
  const updating = useAppSelector(state => state.postDeliveryMonitoring.updating);
  const updateSuccess = useAppSelector(state => state.postDeliveryMonitoring.updateSuccess);
  const painScoreValues = Object.keys(PainScore);

  const handleClose = () => {
    navigate(`/post-delivery-monitoring${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGlucoUsers({}));
    dispatch(getPostOpRecoveries({}));
    dispatch(getPregnancyCases({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.dischargeDate !== undefined && typeof values.dischargeDate !== 'number') {
      values.dischargeDate = Number(values.dischargeDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...postDeliveryMonitoringEntity,
      ...values,
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      recoveryRecord: postOpRecoveries.find(it => it.id.toString() === values.recoveryRecord?.toString()),
      pregnancy: pregnancyCases.find(it => it.id.toString() === values.pregnancy?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          painScore: 'ALDERETE',
          ...postDeliveryMonitoringEntity,
          patient: postDeliveryMonitoringEntity?.patient?.id,
          recoveryRecord: postDeliveryMonitoringEntity?.recoveryRecord?.id,
          pregnancy: postDeliveryMonitoringEntity?.pregnancy?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.postDeliveryMonitoring.home.createOrEditLabel" data-cy="PostDeliveryMonitoringCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.postDeliveryMonitoring.home.createOrEditLabel">
              Create or edit a PostDeliveryMonitoring
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="post-delivery-monitoring-id"
                  label={translate('tinyMedicRestApp.postDeliveryMonitoring.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.postDeliveryMonitoring.dischargeDate')}
                id="post-delivery-monitoring-dischargeDate"
                name="dischargeDate"
                data-cy="dischargeDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postDeliveryMonitoring.painScore')}
                id="post-delivery-monitoring-painScore"
                name="painScore"
                data-cy="painScore"
                type="select"
              >
                {painScoreValues.map(painScore => (
                  <option value={painScore} key={painScore}>
                    {translate(`tinyMedicRestApp.PainScore.${painScore}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.postDeliveryMonitoring.comments')}
                id="post-delivery-monitoring-comments"
                name="comments"
                data-cy="comments"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postDeliveryMonitoring.active')}
                id="post-delivery-monitoring-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postDeliveryMonitoring.draft')}
                id="post-delivery-monitoring-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postDeliveryMonitoring.cursor')}
                id="post-delivery-monitoring-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postDeliveryMonitoring.lastUpdated')}
                id="post-delivery-monitoring-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postDeliveryMonitoring.microSec')}
                id="post-delivery-monitoring-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postDeliveryMonitoring.timestampEntry')}
                id="post-delivery-monitoring-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="post-delivery-monitoring-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.postDeliveryMonitoring.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="post-delivery-monitoring-recoveryRecord"
                name="recoveryRecord"
                data-cy="recoveryRecord"
                label={translate('tinyMedicRestApp.postDeliveryMonitoring.recoveryRecord')}
                type="select"
              >
                <option value="" key="0" />
                {postOpRecoveries
                  ? postOpRecoveries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="post-delivery-monitoring-pregnancy"
                name="pregnancy"
                data-cy="pregnancy"
                label={translate('tinyMedicRestApp.postDeliveryMonitoring.pregnancy')}
                type="select"
              >
                <option value="" key="0" />
                {pregnancyCases
                  ? pregnancyCases.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/post-delivery-monitoring" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PostDeliveryMonitoringUpdate;
